import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryById, selectCategoryEntities } from "../../../../store/mine_craft/categoriesSlice";

import Summary from "../../categories/_partials/_Summary";
import ListVertical from "../../../../componets/ListVertical";
import ListItem from "../../categories/_partials/_ListItem";
import { RightSidebar } from "../../../_partials/Layout";

interface PropsInterface {
  categoryId: any;
}

const _SidebarIndex = ({ categoryId }: PropsInterface) => {
  const category = useAppSelector(state => selectCategoryById(state, categoryId));
  const parentId: any = category?.parent_id || category?.id;
  const parentCategory = useAppSelector(state => selectCategoryById(state, parentId));
  const categories = useAppSelector(selectCategoryEntities);

  if (!category) {
    return null;
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>

      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Category</h6>
      {<Summary category={category} />}

      <h6 className="v-content-label o-sm v-mt-25">Parent</h6>
      {
        parentCategory &&
          <ListVertical>
            <ListItem category={parentCategory} activeId={categoryId} />
          </ListVertical>
      }

      <h6 className="v-content-label o-sm v-mt-25">Subcategories</h6>
      {
        parentCategory &&
          <ListVertical>
            {parentCategory.subcategories.map((id) => <ListItem key={id} category={categories[id]} activeId={categoryId} />)}
          </ListVertical>
      }
    </RightSidebar>
  )
}

export default _SidebarIndex;
